import React from "react";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import styles from "../../../../styles/questionare/button.module.css";

const ActionButtons = ({ Back, Move,disable, buttonText = "Save & Continue"}) => (
  <Box
    sx={{
      width: "100%",
      mt: "2rem",
      mb: "2rem",
      display: "flex",
      justifyContent:disable? "flex-end": "space-between",
    }}
  >
   {!disable && <Button
      variant="outlined"
      style={{ color: "#1C486B", textTransform: "none" }}
      onClick={Back}
    >
      <WestIcon sx={{ mr: 2 }} /> Back
    </Button>}
    <Button
      variant="contained"
      style={{
        backgroundColor: "#1C486B",
        textTransform: "none",
        color: "#fff",
      }}
      onClick={Move}
    >
       {buttonText} <EastIcon sx={{ ml: 2 }} />
    </Button>
  </Box>
);

export default ActionButtons;
